import { useFiltersForQuery } from "src/contexts/filterAndFte/FilterAndFteContext";
import { isPeoplePage, isPeopleSearchPage, isSummaryPage } from "src/util/url";
import { matchPaths } from "src/consts/urlPaths";
import useRestricted from "src/app/Restricted/useRestricted";
import { withSidebarContextProvider } from "./context";
import useSidebarDataQuery from "./useSidebarDataQuery";
import useLocationSidebarEffects from "./useLocationSidebarEffects";
import AppSideNavWrapper from "src/components/AppSideNavWrapper/AppSideNavWrapper";

const SidebarContainer = () => {
  const [isDirectoryUser, isPowerUser, isAdminUser] = useRestricted();
  const match = matchPaths();
  const canLoadPeopleSearchRefineFilters = isPowerUser || isAdminUser;
  const onInsights = isSummaryPage(match?.path);
  const onPeopleSearch = isPeoplePage(match?.path) || isPeopleSearchPage(match);
  const shouldGetFilters = !!(
    (onInsights && !isDirectoryUser) ||
    (onPeopleSearch && canLoadPeopleSearchRefineFilters)
  );

  const filters = useFiltersForQuery();
  useSidebarDataQuery(filters, shouldGetFilters);
  useLocationSidebarEffects();

  return <AppSideNavWrapper />;
};

export default withSidebarContextProvider(SidebarContainer);
